import React from 'react'
import { connect } from 'react-redux'
import { UNIFIED_DISCLAIMER, BRAND_ENDPOINTS } from '../../configuration/terms'

const getUrlEndpoint = brandLetter => {
  let endpoint = ''

  switch (brandLetter) {
    case 'R':
      endpoint = BRAND_ENDPOINTS[brandLetter]
      break

    case 'C':
      endpoint = BRAND_ENDPOINTS[brandLetter]
      break

    default:
      endpoint = BRAND_ENDPOINTS.R + ' and ' + BRAND_ENDPOINTS.C
  }

  return endpoint
}

const GeneralTermsAndConditions = props => {
  let brand = props.brand
  if (!brand) {
    brand =
      props.currentBrands.size === 1
        ? Array.from(props.currentBrands)[0]
        : props.activeSearchFilterData.brand
  }

  const disclaimer = UNIFIED_DISCLAIMER.replaceAll(
    '{brandUrl}',
    getUrlEndpoint(brand)
  )

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: disclaimer
      }}
    />
  )
}

const mapStateToProps = state => {
  const activePackages = Object.keys(state.activePackageData)
  let currentBrands = new Set()
  activePackages.forEach(item => {
    const pkg =
      state.packagesData.allPackages?.[item] ||
      state.cruiseToursData.allPackages?.[item]
    if (pkg) {
      currentBrands.add(pkg.brand)
    }
  })

  return {
    activeSearchFilterData: state.activeSearchFilterData,
    currentBrands,
    ssoData: state.ssoData
  }
}

export default connect(mapStateToProps)(GeneralTermsAndConditions)
